import HeadlessCaptureAgent from '@components/HeadlessCaptureAgent';
import { AiAnalystProvider } from '@providers/AiAnalyst';
import AppProvider from '@providers/App/AppProvider';
import { QuickHelpProvider } from '@providers/QuickHelp';
import MantineProvider from '@providers/Mantine/MantineProvider';
import PhosphorIconsProvider from '@providers/PhosphorIcons/PhosphorIconsProvider';
import ReactQueryProvider from '@providers/ReactQuery/ReactQueryProvider';
import MobileRoutes from '@routes/MobileRoutes';
import WebAppRoutes from '@routes/Routes';
import { wrapCreateBrowserRouterV7 } from '@sentry/react';
import 'react-day-picker/dist/style.css';
import { createBrowserRouter, Outlet, RouterProvider } from 'react-router';

// Sentry wrapper for createBrowserRouter
const sentryCreateBrowserRouter =
    wrapCreateBrowserRouterV7(createBrowserRouter);

const isMobile = window.innerWidth < 768;
const router = sentryCreateBrowserRouter([
    {
        path: '/',
        element: (
            <AppProvider>
                <AiAnalystProvider>
                    <QuickHelpProvider>
                        <HeadlessCaptureAgent />
                        <Outlet />
                    </QuickHelpProvider>
                </AiAnalystProvider>
            </AppProvider>
        ),
        children: isMobile ? MobileRoutes : WebAppRoutes,
    },
]);

const App = () => {
    return (
        <ReactQueryProvider>
            <MantineProvider>
                <PhosphorIconsProvider>
                    <RouterProvider router={router} />
                </PhosphorIconsProvider>
            </MantineProvider>
        </ReactQueryProvider>
    );
};

export default App;
